module.exports = Em.View.extend({
    classNames: ['user-menu']
})
